export enum EmailTab {
  NewAndValidatedUnreadCount = 0,
  NotValidatedUnreadCount = 1,
  ReassignedUnreadCount = 2,
}
